/**
 * @generated SignedSource<<ed4871b8798af7b7b6b4dc64ce3af755>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Subscription_subscribable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowSendingNotificationOnContentUpdate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alreadySubscribed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subscribersCount",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SubscriptionModal_subscribable"
    }
  ],
  "type": "ResourceTreeLeaf",
  "abstractKey": "__isResourceTreeLeaf"
};

node.hash = "c9dd2cb7eb46f161d626d9ec79a34a1e";

module.exports = node;
